export const RECORDING_SETTINGS_TRACKED_FIELDS = [
  'videoQuality',
  'videoSource.label',
  'audioSource.label',
];

export const MY_PROFILE_TRACKED_FIELDS = [
  'firstName',
  'lastName',
  'email2',
  'phone1',
  'phone2',
  'cellPhone',
  'userTitle',
  'website',
  'department',
  'language',
  'signature',
  'timezone',
  'playButtonPosition',
  'videoShareLinkText',
  'notificationPreferences',
];
